import Message from './message';

interface ResponseMessageJson {
  response_id: string;
  name: string;
  meta: Record<string, string> | undefined;
  payload: Record<string, string>;
}
export default class ResponseMessage extends Message {
  public toJson(): ResponseMessageJson {
    return {
      response_id: this.id,
      name: this.name,
      meta: this.meta,
      payload: this.payload || {},
    };
  }

  public static isResponse(data: Record<string, any>): boolean {
    return !!data.response_id;
  }

  public static from(data: Record<string, any>): ResponseMessage | undefined {
    if (data.name && data.response_id && data.payload) {
      const response = data as ResponseMessageJson;
      return new ResponseMessage(
        response.response_id,
        response.name,
        response.meta,
        response.payload,
      );
    }
    return undefined;
  }
}
